import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleDown, faAngleUp, faSortAlphaUp } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';
import { BrandFilterType, FilterType, SpecFilter } from 'src/app/core/models/filter.model';
import { FilterService } from 'src/app/core/services/filter.service';
import { environment } from 'src/environments/environment';
import { convertStrToUrl } from 'src/app/core/utils';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-car-filters',
  templateUrl: './car-filters.component.html',
  styleUrls: ['./car-filters.component.scss',],
})
export class CarFiltersComponent implements OnInit {

  faAngleUp = faAngleUp;
  faAngleDown = faAngleDown;
  faSortAlphaUp = faSortAlphaUp;
  isLoading: boolean = false;
  specFilter: SpecFilter[] = [];
  selectedFilters: string[] = [];
  brandFilterTypes: BrandFilterType[] = [];
  isPumPumPum: boolean = environment.source.toLowerCase() === 'pumpumpum';
  currentCity?: string;
  showAllBrands: boolean = false;

  @Output() filterChanged = new EventEmitter<any>();
  isBrowser: boolean;
  constructor(
    private _filterService: FilterService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this._activatedRoute.queryParams.subscribe({
      next: (data) => {
        this.selectedFilters = [];
        Object.keys(data).forEach(key => {
          const selectedParam = data[key];
          selectedParam.split(',').forEach((data: string) => {
            this.selectedFilters.push(data);
          });
        });
      },
    });
  }

  ngOnInit(): void {
    this._activatedRoute.paramMap.subscribe({
      next: () => {
        this.getFilters();
        const { url, } = this._router;
        const category = url.split('-car-')[AppConstants.ZERO]?.split('/').pop();
        if (category) this.selectedFilters.push(category);
      },
    });
  }

  isSelected(data: string): boolean {
    return this.selectedFilters.includes(data.toString());
  }

  getFilters() {
    this.isLoading = true;
    this._filterService.getFilterTypes().subscribe({
      next: (data: FilterType) => {
        this.specFilter = data.specFilters.map((d: SpecFilter) => {
          // Add isOpen for collapsible side filters
          const data: SpecFilter = { ...d, isOpen: true, };
          return data;
        });
        this.brandFilterTypes = data.brands.map((b: BrandFilterType) => {
          const data: BrandFilterType = { ...b, isOpen: false, };
          return data;
        });
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  toggleFilters(index: number) {
    this.specFilter[index].isOpen = !this.specFilter[index].isOpen;
  }

  toggleBrandFilters(index: number) {
    this.brandFilterTypes[index].isOpen = !this.brandFilterTypes[index].isOpen;
  }

  onCheck(i: number, j: number) {
    const { key, } = this.specFilter[i];
    const value = this.specFilter[i].value[j];
    const params: any = {};
    params[key] = `${value}`;
    this.onFilterChanged(params);
  }

  onBrandCheck(brandFilter: BrandFilterType) {
    this.onFilterChanged({
      'brand': brandFilter.brand.name,
    });
  }

  onModelCheck(i: number, j: number) {
    const model = this.brandFilterTypes[i].models[j].name;
    this.onFilterChanged({ model, });
  }

  transformParams(oldParams: any, key: string, value: string) {
    // If key exist in current query params
    const existingParam = oldParams[key];
    if (existingParam) {
      const newParams = existingParam?.split(',');
      const i = newParams.indexOf(value);
      // If value already exist
      if (i >= AppConstants.ZERO) {
        // Remove value
        newParams.splice(i, AppConstants.ONE);
        // Remove key if no value
        oldParams[key] = newParams.length ? newParams.toString() : undefined;
      } else {
        // Append to values
        oldParams[key] = `${existingParam.toString()},${value}`;
      }
    } else {
      // Key not found add to query params
      oldParams[key] = value;
    }
  }

  /**
   * ShouldReset is true when apply filter is click on filter popup from mobile view
   * @param params Query params
   * @param shouldReset Should reset query params
   */
  onFilterChanged(params: any, shouldReset = false) {
    let oldParams = { ...this._activatedRoute.snapshot.queryParams, };
    if (shouldReset) {
      oldParams = {};
    }

    Object.keys(params).forEach((k: string) => {
      this.transformParams(oldParams, k, params[k]);
    });

    const { brand, model, transmissionType, fuelType, bodyType, } = oldParams;
    if (!brand && !model && !transmissionType && !fuelType && !bodyType) {
      this._router.navigate(['cars',], { queryParams: oldParams, });
      return;
    }

    let url = '';
    if (model && model.split(',').length === AppConstants.ONE) {
      url = `model/${model}-car-subscription`;
    } else if (brand && brand.split(',').length === AppConstants.ONE) {
      url = `brand/${brand}-car-subscription`;
    } else if (transmissionType && transmissionType.split(',').length === AppConstants.ONE) {
      url = `curated/${transmissionType}-car-subscription`;
    } else if (fuelType && fuelType.split(',').length === AppConstants.ONE) {
      url = `curated/${fuelType}-car-subscription`;
    } else if (bodyType && bodyType.split(',').length === AppConstants.ONE) {
      url = `curated/${bodyType}-car-subscription`;
    } else {
      url = 'cars';
    }
    this.filterChanged.emit({ params: { ...oldParams, page: undefined, }, url: convertStrToUrl(url), });
  }


}
